import { type FC } from "react";
import type { PickupButtonContentProps } from "@clientFrontend/features/scout/components/UserDetailModal/uiParts/Header";
import type { UserHiddenButtonContent } from "@clientFrontend/features/scout/types/userHidden";
import { Presentation } from "./Presentation";
import { useUserDetailModal } from "./useUserDetailModal";

// 自由記述欄を畳む高さ
// 文字サイズが大きい場合
const MAX_DISPLAY_LARGE_TEXT_HEIGHT = 120;
// 文字サイズが小さい場合
const MAX_DISPLAY_SMALL_TEXT_HEIGHT = 60;

type Props = {
  fetchUrl: string;
  pickupButtonContent?: PickupButtonContentProps;
  userHiddenButtonContent?: UserHiddenButtonContent;
  isShowScoutButton?: boolean;
  handleOnClickClose: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const UserDetailModal: FC<Props> = ({
  fetchUrl,
  pickupButtonContent,
  userHiddenButtonContent,
  isShowScoutButton = true,
  handleOnClickClose,
}) => {
  const content = useUserDetailModal(fetchUrl, pickupButtonContent, userHiddenButtonContent);
  const showReadMoreButtonControlInformation = {
    showReadMoreButton: true,
    maxDisplayLargeTextHeight: MAX_DISPLAY_LARGE_TEXT_HEIGHT,
    maxDisplaySmallTextHeight: MAX_DISPLAY_SMALL_TEXT_HEIGHT,
  };
  return (
    <Presentation
      content={content}
      isShowScoutButton={isShowScoutButton}
      handleOnClickClose={handleOnClickClose}
      showReadMoreButtonControlInformation={showReadMoreButtonControlInformation}
    />
  );
};
